<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="requestDesign" class="modal-window-content">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>Request Design Quotation</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div class="siklu-mat-dialog-body" matDialogContent>
        <div>
            <div class="mb-4">
                Built on Siklu and designed by experts!<br />
                Siklu offers complete network planning and design for customer networks, providing an optimized solution to meet customers’
                business needs.<br />
                Siklu’s professional services team, with its extensive knowledge and experience, delivers the highest level of expertise in
                network planning following a detailed requirements gathering and alternatives study.<br />
                Siklu planning and design benefits:
                <ul class="">
                    <li>Optimized architecture and product selection</li>
                    <li>Line of sight validation (using publically available GIS databases)</li>
                    <li>Network performance analysis (availability, capacity, resiliency)</li>
                    <li>Frequency assignment and interference analysis</li>
                    <li>Detailed Bill Of Materials</li>
                </ul>
            </div>
            <div>
                Please complete this form to request quotation for network planning and design by Siklu’s professional services team.
                Quotation will based on size of the network and availability of GIS data for the location.<br />
                Please include in your request detailed network description and design requirements, including the following info so we can
                evaluate your request and respond promptly:<br />
                <ul class="">
                    <li>Target capacity (Mbps) per site</li>
                    <li>Network ingress locations (fiber POPs)</li>
                    <li>Accurately located sites as a KMZ/KML file. If sites already loaded on the planner, no need for KMZ/KML file.</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="report-problem-title">Request title</label>
            <input
                [(ngModel)]="requestDesign.title"
                class="form-control"
                id="report-problem-title"
                name="report-problem-title"
                type="text"
            />
        </div>
        <div class="form-group">
            <label for="report-problem-description">Request description</label>
            <textarea
                [(ngModel)]="requestDesign.description"
                class="form-control"
                id="report-problem-description"
                name="report-problem-description"
                rows="5"
            ></textarea>
        </div>
        <p class="mb-0">Please allow us up to 2 business days to respond.</p>
        <div class="multiple-files">
            <ul class="multiple-files__list">
                <li *ngFor="let file of attachedFiles" class="multiple-files__item">
                    {{ file.name }}
                    <button (click)="removeFileFromList(file)" class="multiple-files__remove-item" windeActionIcon>
                        <sui-svg-icon icon="cross" windeRed />
                    </button>
                </li>
            </ul>
            <label class="btn btn-sm btn-add-file" for="file-upload">
                <sui-svg-icon icon="file-text" windeGrey />
                Select files
            </label>
            <input (change)="changeFiles($event)" class="d-none" id="file-upload" multiple name="file-upload" type="file" />
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button (click)="sendReport()" [disabled]="isSending" windeGreen>Send</button>
    </div>
</div>
